window.__APP__ = {
  BASE_API_URL: import.meta.env.VITE_BASE_API_URL || 'api-jobseeker.site',
  SOURCE_APP: import.meta.env.VITE_SOURCE_APP || 'hrms-basic',
  API_VERSION: import.meta.env.VITE_API_VERSION || '5.1',
  SOURCE_LANG: import.meta.env.VITE_SOURCE_LANG || 'en',
  TINYMCE_API_KEY: import.meta.env.VITE_TINYMCE_API_KEY || '',
}
